// ProjectForm Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import FormButton from '../../../common/form/button/button.jsx'
import Input from '../../../common/form/input/input.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import FormDatePicker from '../../../common/form/form_datepicker/form_datepicker.jsx'
import InputTag from '../../../common/form/input_tag/input_tag.jsx'
import ProjectStatus from '../../project/project_status/project_status.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Util from '../../../lib/util.jsx'
import ContactForm from '../../../contact/form/contact_form/contact_form.jsx'
import ContactUtil from '../../../lib/contactutil.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class ProjectForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      stepIndex: 1,
      title: '',
      contactId: '',
      projectNumber: '',
      previousProjectNumber: '',
      contactName: '',
      startDate: null,
      endDate: null,
      closeDate: null,
      status: 'active',
      tags: [],
      displayContactName: '',
      autoFocus: true,
      showDetail: false,
      showStatus: false
    }

    this.data = {
      project: null,
      contact: {
        addresses: [
          {
            type: 'Office',
            street: '',
            streetNumber: '',
            postcode: '',
            city: '',
            country: props.teamCountry
          }
        ],
        contactPersons: [],
        rateCards: [],
        paymentDays: -1,
        rateMarkup: this.props.rateMarkup ? this.props.rateMarkup : 0
      },
      contacts: [],
      searchTimer: 0,
      bToday: true,
      bSupporNo: false,
      bIsNoAutoGenerated: false
    }

    this._references = {
      inputTitle: React.createRef(),
      projectNumber: React.createRef(),
      inputContact: React.createRef(),
      contactForm: React.createRef()
    }

    this.showStartDateButtons = false
    this.showDeadlineDateButtons = false
    this._bContactSearchPending = null
    this._contactSearchKeyword = ''
  }

  static get propTypes () {
    return {
      withoutContext: PropTypes.bool,
      tagSuggestions: PropTypes.array,
      teamPaymentDays: PropTypes.number,
      prefixCurrency: PropTypes.string,
      teamCountry: PropTypes.string,
      onSubmit: PropTypes.func,
      contactSearch: PropTypes.func,
      onClose: PropTypes.func,
      getProjectNumber: PropTypes.func,
      rateMarkup: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      withoutContext: false,
      tagSuggestions: [],
      teamPaymentDays: 0,
      prefixCurrency: '',
      teamCountry: '',
      onSubmit: null,
      contactSearch: null,
      onClose: null,
      getProjectNumber: null,
      rateMarkup: 0
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (_nextProps) {
    if (this._references.inputContact.current) {
      this._references.inputContact.current.hideAdd()
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._handleDocumentKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._handleDocumentKeyDown)
  }

  /* Event handlers */
  _handleDocumentKeyDown = evt => {
    const keyCode = evt.keyCode

    if (keyCode === 27 && this.state.active) {
      this._onClickClose(evt)

      return false
    }
  }

  show (
    project,
    nextProjectNo,
    previousProjectNo,
    bSupportNo,
    bIsNoAutoGenerated
  ) {
    FabButtonManager.setVisible(false)
    const stateObj = { active: true, autoFocus: true }
    const currDate = DateUtil.getUTCCurrentDate()
    if (project !== undefined && project) {
      this.data.project = project
      this.data.bSupportNo = bSupportNo
      this.data.bIsNoAutoGenerated = bIsNoAutoGenerated

      const tags = []
      if (project.tags && project.tags.length > 0) {
        project.tags.map(tag => {
          tags.push({ text: tag.toLowerCase() })
        })
      }

      stateObj.title = project.title
      stateObj.contactId = project.contactId
      stateObj.tags = tags
      stateObj.status = project.status
      stateObj.displayContactName = project.contact
        ? project.contact.company
        : ''
      stateObj.projectNumber = nextProjectNo
      stateObj.previousProjectNumber = previousProjectNo

      const startDate = {}
      startDate.bToday = !!(
        project.startDate &&
        DateUtil.isDateEqual(currDate, new Date(project.startDate))
      )
      startDate.date = project.startDate ? new Date(project.startDate) : ''
      stateObj.startDate = startDate

      const endDate = {}
      endDate.bToday = !!(
        project.endDate &&
        DateUtil.isDateEqual(currDate, new Date(project.endDate))
      )
      endDate.date = project.endDate ? new Date(project.endDate) : ''
      stateObj.endDate = endDate

      const closeDate = {}
      closeDate.bToday = !!(
        project.closeDate &&
        DateUtil.isDateEqual(currDate, new Date(project.closeDate))
      )
      closeDate.date = project.closeDate ? new Date(project.closeDate) : ''
      stateObj.closeDate = closeDate
    }

    this.setState(stateObj)
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.data.project = null
    this.data.contact = {
      addresses: [],
      contactPersons: [],
      rateCards: [],
      paymentDays: -1
    }
    this.data.contacts = []
    this.data.bToday = true
    this.data.bSupporNo = false
    this.data.bIsNoAutoGenerated = false
    this.setState({
      active: false,
      stepIndex: 1,
      title: '',
      contactId: '',
      projectNumber: '',
      previousProjectNumber: '',
      contactName: '',
      startDate: '',
      endDate: '',
      tags: [],
      closeDate: '',
      status: 'active',
      titleErr: '',
      contactErr: '',
      displayContactName: '',
      autoFocus: false,
      showContactForm: false
    })

    if (this._references.inputContact.current) {
      this._references.inputContact.current.hideAdd()
      this._references.inputContact.current.clearError()
    }

    if (this._references.projectNumber.current) {
      this._references.projectNumber.current.clearError()
    }

    this.showStartDateButtons = false
    this.showDeadlineDateButtons = false
  }

  onAfterContactCreated (contactId) {
    if (this._references.inputContact.current) {
      this._references.inputContact.current.hideAddAndSelection()
    }

    this.setState({
      contactId: contactId,
      displayContactName: this.state.contactName,
      contactName: ''
    })
  }

  clearProjectName () {
    this.setState({
      title: ''
    })
  }

  render () {
    const _wizCls = classnames('wizard-form', {
      active: this.state.active
    })

    return (
      <div className={_wizCls}>
        <form
          className='form projectform'
          method='post'
          onSubmit={this._handleSubmit.bind(this)}
        >
          <div className='wfrmstepinfo'>
            <IconButton
              icon='wizard-close'
              className='modal wizard-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
            {this._renderStepsInfo()}
            {this._renderStepsAction()}
          </div>
          <div className='wfrmstepcontent'>
            {this._renderStepsContent()}
            <div className='stepsaction'>
              <IconButton
                className='wizard-submit'
                icon='common-success-tick'
                title='project.form.tipSave'
                canHover={false}
                type='primary'
                size='big'
                tooltip='project.form.tipSaveClose'
                tooltipPosition='top'
                onClick={this._handleSubmit.bind(this)}
              />
            </div>
          </div>
        </form>
      </div>
    )
  }

  /* Event handlers */
  _handleSubmit (ev) {
    ev.preventDefault()

    let noErrors = 0
    if (
      this._references.inputTitle.current &&
      !this._references.inputTitle.current.validate()
    ) {
      noErrors++
    }
    if (
      this._references.projectNumber.current &&
      !this._references.projectNumber.current.validate()
    ) {
      noErrors++
    }

    const newClientName = this.state.contactName ? this.state.contactName : null
    if (!newClientName) {
      if (
        this._references.inputContact.current &&
        (!this._references.inputContact.current.validate() ||
          !this.state.contactId)
      ) {
        noErrors++
        this._references.inputContact.current.showError()
      }
    }

    if (
      this._references.contactForm.current &&
      !this._references.contactForm.current.validate()
    ) {
      noErrors++
    }

    if (noErrors === 0) {
      const tags = []
      if (this.state.tags && this.state.tags.length > 0) {
        this.state.tags.map(tag => {
          if (tag.text) {
            tags.push(tag.text.toLowerCase())
          }
        })
      }

      const data = {
        title: this.state.title,
        contactId: newClientName ? null : this.state.contactId,
        projectNumber: this.state.projectNumber,
        startDate: this.state.startDate.date
          ? new Date(this.state.startDate.date)
          : null,
        endDate: this.state.endDate.date
          ? new Date(this.state.endDate.date)
          : null,
        closeDate:
          this.state.closeDate && this.state.closeDate.date
            ? new Date(this.state.closeDate.date)
            : null,
        tags: tags
      }

      const projectId = this.data.project.id ? this.data.project.id : null
      let contactData = {}
      if (newClientName && this._references.contactForm.current) {
        contactData = this._references.contactForm.current.getContact() || {}

        const website =
          contactData && contactData.website ? contactData.website : ''
        if (
          website &&
          website.indexOf('http://') === -1 &&
          website.indexOf('https://') === -1
        ) {
          contactData.website = `http://${website}`
        }
      } else {
        contactData = this.data.contact || {}
        contactData.contactPersons = []
      }

      if (projectId === null) {
        data.status = this.state.status
      }

      this.props.onSubmit(data, projectId, newClientName, contactData)
    }
  }

  _onClickDate (name, value, ev) {
    ev.preventDefault()

    const curDate = DateUtil.getUTCCurrentDate()
    const info = {}
    if (value === 'today') {
      info.bToday = true
      info.date = curDate
    } else if (value === 'yesterday') {
      info.bToday = false
      info.date = new Date(
        curDate.getFullYear(),
        curDate.getMonth(),
        curDate.getDate() - 1,
        curDate.getHours(),
        curDate.getMinutes(),
        curDate.getSeconds()
      )
    } else if (value === 'noDate') {
      info.bToday = false
      info.date = ''
    }

    this.showStartDateButtons = false
    this.showDeadlineDateButtons = false

    this.setState({ [name]: info })
  }

  _onChangeInput (name, value) {
    if (name === 'title') {
      this.setState({ title: value, autoFocus: false })
    } else {
      this.setState({ [name]: value })
    }
    if (name === 'projectNumber') {
      this.setState({ projectNumber: value, autoFocus: false })
    } else {
      this.setState({ [name]: value })
    }
  }

  _onContactAddToggle (bAddShown) {
    if (bAddShown) {
      this.setState({
        contactId: null,
        contactName: this.state.displayContactName,
        showDetail: true,
        showContactForm: false
      })
    } else {
      if (this._references.contactForm.current) {
        this.data.contact = this._references.contactForm.current.getContact()
      }
      this.setState({
        contactId: null,
        contactName: '',
        showDetail: true,
        showContactForm: false
      })
    }
  }

  _handleStepChange (step, e) {
    e.preventDefault()

    if (this.state.showContactForm && this._references.contactForm.current) {
      if (this._references.contactForm.current.validate()) {
        this.data.contact = this._references.contactForm.current.getContact()
      }
    }

    this.setState({ stepIndex: step })
  }

  _onClickClose (ev) {
    ev.preventDefault()

    if (this.props.onClose) {
      if (
        this.data.project &&
        this.data.project.id &&
        this._references.projectNumber.current
      ) {
        if (this.data.project.projectNumber) {
          this.props.onClose()
        } else {
          this._references.projectNumber.current.showError()
        }
      } else {
        this.props.onClose()
      }
    }
  }

  _getValidateClass (step) {
    return classnames('stepinfo', {
      active: this.state.stepIndex === step,
      complete: this._getIsCompleted(step),
      error: this._getHasError(step)
    })
  }

  _getIsCompleted (step) {
    let bComplete = false
    if (step === 1) {
      bComplete =
        this.state.title && (this.state.contactId || this.state.contactName)
    } else if (step === 2) {
      bComplete = this.state.startDate && this.state.endDate
    } else if (step === 3) {
      bComplete = this.state.tags.length > 0
    } else if (step === 4) {
      bComplete = !this.state.status
    }

    return bComplete
  }

  _getHasError (step) {
    let bError = false
    if (step === 1) {
      bError =
        !this.state.title || (!this.state.contactId && !this.state.contactName)
    }

    return bError
  }

  _formatDate (value) {
    if (typeof value !== 'object') {
      return value
    }

    return DateUtil.getDisplayDate(value)
  }

  _handleSearchContact (keyword) {
    this.setState({ displayContactName: keyword })
    this._processContactSearch(keyword)
  }

  _processContactSearch (keyword) {
    if (keyword.length < 1) return

    if (!this._bContactSearchPending) {
      this._bContactSearchPending = true
      if (this.props.contactSearch) {
        this.props.contactSearch(
          keyword,
          this._onSearchRecieved.bind(this, keyword)
        )
      }
    } else {
      this._contactSearchKeyword = keyword
    }
  }

  _onSearchRecieved (keyword, result) {
    this._bContactSearchPending = false

    this.data.contacts = result
    const stateObj = {}
    if (result && result.length > 0) {
      stateObj.contactId = ''
      stateObj.contactName = ''
    }

    this.setState(stateObj)

    if (this._contactSearchKeyword) {
      const keyword = this._contactSearchKeyword
      this._contactSearchKeyword = ''
      this._processContactSearch(keyword)
    }
  }

  _handleContactSelect (name, obj) {
    if (obj) {
      this.setState({
        [name]: obj.value,
        displayContactName: obj.label,
        autoFocus: false
      })
      if (this.props.getProjectNumber) {
        this.props
          .getProjectNumber(this.data.bIsNoAutoGenerated, obj.value)
          .then(projectNumber => {
            this.setState({ previousProjectNumber: projectNumber })
          })
      }
    } else {
      this.setState({ [name]: '', autoFocus: false })
    }
  }

  _onChangeProjectStatus (stateObj) {
    this.setState({ status: stateObj.status, closeDate: stateObj.closeDate })
  }

  _onUpdateTags (tags) {
    this.setState({ tags: tags })
  }

  _onBlurInput () {
    this.setState({ autoFocus: false })
  }

  _onClickMoreDetail (ev) {
    ev.preventDefault()
    this.setState({ showContactForm: true, showDetail: false })
  }

  _onClickContactFormClose (ev) {
    ev.preventDefault()
    this.setState({ showContactForm: false, showDetail: true })
  }

  /* Private functions */
  _renderStepsContent () {
    return (
      <div className='stepscontent'>
        {this._renderStep1()}
        {this._renderStep2()}
        {this._renderStep3()}
        {this._renderStep4()}
      </div>
    )
  }

  _renderStartDateButtons () {
    if (!this.showStartDateButtons) {
      return ''
    }

    return (
      <div className='formcol2'>
        <FormButton
          title='project.form.actionToday'
          className={`wizard${this.state.startDate.bToday ? '' : 'alt'}`}
          type='text'
          onClick={this._onClickDate.bind(this, 'startDate', 'today')}
        />
        <FormButton
          title='project.form.actionStart'
          type='text'
          className={`wizard${this.state.startDate.bToday ? 'alt' : ''}`}
          onClick={this._onClickDate.bind(this, 'startDate', 'noDate')}
        />
      </div>
    )
  }

  _renderDeadlineDateButtons () {
    if (!this.showDeadlineDateButtons) {
      return ''
    }

    return (
      <div className='formcol2'>
        <FormButton
          title='project.form.actionAsap'
          className={`wizard${this.state.endDate.bToday ? '' : 'alt'}`}
          type='text'
          onClick={this._onClickDate.bind(this, 'endDate', 'today')}
        />
        <FormButton
          title='project.form.actionNoPressure'
          className={`wizard${this.state.endDate.bToday ? 'alt' : ''}`}
          type='text'
          onClick={this._onClickDate.bind(this, 'endDate', 'noDate')}
        />
      </div>
    )
  }

  _renderStepsInfo () {
    const { startDate, endDate, showStatus } = this.state
    let prjInfo = IntlUtil.convertMessage('project.form.noNameAdded')
    if (this.state.title && (this.state.contactId || this.state.contactName)) {
      let dispVal = ''
      if (this.state.contactId) {
        dispVal = this.state.displayContactName
      } else {
        dispVal = this.state.contactName
      }
      prjInfo = `${this.state.title} - ${dispVal}`
    }

    let dateInfo = IntlUtil.convertMessage('project.form.noDateSelected')
    if ((startDate && startDate.date) || (endDate && endDate.date)) {
      dateInfo = `${
        startDate.date ? this._formatDate(startDate.date) : '...'
      } - ${endDate.date ? this._formatDate(endDate.date) : '...'}`
    }

    let tagInfo = IntlUtil.convertMessage('project.form.noTagsAdded')
    if (this.state.tags.length > 0) {
      tagInfo = IntlUtil.convertMessage('project.form.tagsAdded')
    }

    const statusTick = <i className='icon icon-list-tick' />

    return (
      <div className='stepsinfo'>
        <div
          className={this._getValidateClass(1)}
          onClick={this._handleStepChange.bind(this, 1)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(1) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='project.form.stepProject' />
            </h4>
            <div className='info'>{prjInfo}</div>
          </div>
        </div>
        <div
          className={this._getValidateClass(2)}
          onClick={this._handleStepChange.bind(this, 2)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(2) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='project.form.stepPlanning' />
            </h4>
            <div className='info'>{dateInfo}</div>
          </div>
        </div>
        <div
          className={this._getValidateClass(3)}
          onClick={this._handleStepChange.bind(this, 3)}
        >
          <div className='stepstatus'>
            {this._getIsCompleted(3) ? statusTick : ''}
          </div>
          <div className='stepitem'>
            <h4>
              <IntlMessage ident='project.form.stepTags' />
            </h4>
            <div className='info'>{tagInfo}</div>
          </div>
        </div>
        {showStatus && (
          <div
            className={this._getValidateClass(4)}
            onClick={this._handleStepChange.bind(this, 4)}
          >
            <div className='stepstatus has-icon'>
              {this._getIsCompleted(4) ? statusTick : ''}
            </div>
            <div className='stepitem'>
              <h4>
                <IntlMessage ident='project.form.stepStatus' />
              </h4>
              <div className='info status'>
                <IntlMessage
                  ident={Util.getTranslatedStatus(this.state.status)}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  _renderStepsAction () {
    if (!this.state.active) {
      return ''
    }

    let prevStepClass = 'wizard wizardprev disabled'
    let nextStepClass = 'wizard wizardnext disabled'

    if (this.state.stepIndex > 1) {
      prevStepClass = 'wizard wizardprev'
    }

    if (this.state.stepIndex < 3) {
      nextStepClass = 'wizard wizardnext'
    }

    return (
      <div className='stepsaction'>
        <IconButton
          className={prevStepClass}
          icon='common-previousstep'
          title='project.form.tipPreviousStep'
          canHover={false}
          size='big'
          tooltip='project.form.tipPreviousStep'
          tooltipPosition='top'
          onClick={this._handleStepChange.bind(this, this.state.stepIndex - 1)}
        />
        <IconButton
          className={nextStepClass}
          icon='common-nextstep'
          title='project.form.tipNextStep'
          canHover={false}
          size='big'
          tooltip='project.form.tipNextStep'
          tooltipPosition='top'
          onClick={this._handleStepChange.bind(this, this.state.stepIndex + 1)}
        />
        <IconButton
          className='wizard-submit'
          icon='common-success-tick'
          title='project.form.tipSave'
          canHover={false}
          type='primary'
          size='big'
          onClick={this._handleSubmit.bind(this)}
        />
      </div>
    )
  }

  _renderStep1 () {
    if (this.state.stepIndex !== 1) {
      return ''
    }

    let contactName = ''
    if (this.data.project && this.data.project.contact) {
      contactName = this.data.project.contact.company
    }

    const newClientName = this.state.contactName ? this.state.contactName : null
    const { previousProjectNumber } = this.state

    const autoFocus = this.state.autoFocus

    return (
      <div className='wizardstep'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h2>
                  <IntlMessage ident='project.form.stepProjectFormTitle' />
                </h2>
              </div>
              {this.data.bSupportNo && this.data.bIsNoAutoGenerated && (
                <div className='formrow'>
                  <div className='formcol'>
                    <Input
                      type='text'
                      name='title'
                      label='project.form.projectNumber'
                      value={this.state.projectNumber}
                      size={10}
                      maxLength={100}
                      disabled
                    />
                  </div>
                </div>
              )}
              <div className='formrow'>
                <div className='formcol'>
                  <FormAutoComplete
                    label='project.form.client'
                    name='contactId'
                    ref={this._references.inputContact}
                    validations={['required']}
                    autoFocus={autoFocus}
                    value={contactName}
                    displayValue={this.state.displayContactName}
                    options={this.data.contacts}
                    onChange={this._handleSearchContact.bind(this)}
                    onSelect={this._handleContactSelect.bind(this, 'contactId')}
                    addLabel='project.form.addNewClient'
                    addValue={this.state.contactName}
                    addName='contactName'
                    onAddChange={this._onChangeInput.bind(this, 'contactName')}
                    onToggleAdd={this._onContactAddToggle.bind(this)}
                    showAdd={!!newClientName}
                    hasAutoSelect
                    onBlur={this._onBlurInput.bind(this)}
                  />
                </div>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Input
                    type='text'
                    name='title'
                    label='project.form.projectTitle'
                    value={this.state.title}
                    size={10}
                    maxLength={100}
                    validations={['required']}
                    onChange={this._onChangeInput.bind(this, 'title')}
                    onBlur={this._onBlurInput.bind(this)}
                    ref={this._references.inputTitle}
                  />
                </div>
              </div>
              {this.data.bSupportNo && !this.data.bIsNoAutoGenerated && (
                <div className='formrow'>
                  <div className='formcol'>
                    <Input
                      type='text'
                      name='projectNumber'
                      label='project.form.projectNumber'
                      value={this.state.projectNumber}
                      size={10}
                      maxLength={100}
                      validations={['required']}
                      onChange={this._onChangeInput.bind(this, 'projectNumber')}
                      onBlur={this._onBlurInput.bind(this)}
                      ref={this._references.projectNumber}
                    />
                    <span
                      className='info'
                      onClick={this._onChangePreviousProjectNumber.bind(
                        this,
                        'projectNumber'
                      )}
                    >
                      {IntlUtil.convertMessage(
                        this.state.contactId
                          ? 'project.form.lastUsedNumberForClient'
                          : 'project.form.lastUsedNumber'
                      ) +
                        ' ' +
                        previousProjectNumber}
                    </span>
                  </div>
                </div>
              )}
              {this.state.contactName && this.state.showDetail && (
                <div className='formrow'>
                  <a
                    href='#'
                    className='formlink'
                    title={IntlUtil.convertMessage(
                      'project.form.addMoreDetails'
                    )}
                    onClick={this._onClickMoreDetail.bind(this)}
                  >
                    <IntlMessage ident='project.form.addMoreDetails' />
                  </a>
                </div>
              )}
              {this.state.showContactForm && (
                <div className='formrow formrow_close'>
                  <IconButton
                    icon='popup-close'
                    className='modal'
                    canHover
                    onClick={this._onClickContactFormClose.bind(this)}
                  />
                  <ContactForm
                    contact={this.data.contact}
                    teamPaymentDays={this.props.teamPaymentDays}
                    ref={this._references.contactForm}
                    showHeader={false}
                    teamCountry={this.props.teamCountry}
                    prefixCurrency={this.props.prefixCurrency}
                    onSubmit={this._handleSubmit.bind(this)}
                    onVatValidate={this._onVatValidate.bind(this)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onChangePreviousProjectNumber (name) {
    const { previousProjectNumber } = this.state
    if (name === 'projectNumber') {
      this.setState({
        projectNumber: previousProjectNumber,
        autoFocus: false,
        dataDate: new Date()
      })
    }
  }

  _onFocus (name, _value) {
    if (name === 'startDate') {
      this.showStartDateButtons = true
      this.showDeadlineDateButtons = false
    } else if (name === 'endDate') {
      this.showDeadlineDateButtons = true
      this.showStartDateButtons = false
    }

    this.setState({ dataDate: new Date() })
  }

  _onChangeDate (name, value) {
    const dateInfo = this.state[name] || {}
    dateInfo.date = value

    this.setState({ [name]: dateInfo })
  }

  _onValidateDate (endDate) {
    // If date is null, return true to avoid infinite looping
    if (
      !endDate ||
      !this.state.startDate ||
      !this.state.startDate.date ||
      !(this.state.startDate.date instanceof Date)
    ) {
      return true
    }

    return endDate.isAfter(this.state.startDate.date)
  }

  _onVatValidate (country, vatNo, callback) {
    ContactUtil.onVatValidate(country, vatNo, callback)
  }

  _renderStep2 () {
    if (this.state.stepIndex !== 2) {
      return ''
    }

    return (
      <div className='wizardstep'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h2>
                  <IntlMessage ident='project.form.stepPlanningFormTitle' />
                </h2>
              </div>
              <div className='formrow'>
                <div className='formcol2'>
                  <FormDatePicker
                    label='project.form.projectStartDate'
                    placeholder='project.form.noStartDatePlaceholder'
                    value={this.state.startDate.date}
                    name='startDate'
                    onChange={this._onChangeDate.bind(this, 'startDate')}
                    onFocus={this._onFocus.bind(this, 'startDate')}
                  />
                </div>
                {this._renderStartDateButtons()}
              </div>
              <div className='formrow'>
                <div className='formcol2'>
                  <FormDatePicker
                    label='project.form.projectDeadline'
                    placeholder='project.form.noDeadLinePlaceholder'
                    value={this.state.endDate.date}
                    name='endDate'
                    onChange={this._onChangeDate.bind(this, 'endDate')}
                    onFocus={this._onFocus.bind(this, 'endDate')}
                    onValidateDate={this._onValidateDate.bind(this)}
                  />
                </div>
                {this._renderDeadlineDateButtons()}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderStep3 () {
    if (this.state.stepIndex !== 3) {
      return ''
    }

    return (
      <div className='wizardstep'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h2>
                  <IntlMessage ident='project.form.stepTagsFormTitle' />
                </h2>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <InputTag
                    placeholder='project.form.addTag'
                    tags={this.state.tags}
                    tagSuggestions={this.props.tagSuggestions}
                    withoutContext={this.props.withoutContext}
                    onUpdateTags={this._onUpdateTags.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderStep4 () {
    if (this.state.stepIndex !== 4) {
      return ''
    }

    const closeDate =
      this.state.closeDate && this.state.closeDate.date
        ? this.state.closeDate.date
        : DateUtil.getUTCCurrentDate()

    return (
      <div className='wizardstep'>
        <div className='form-layout'>
          <div className='layoutcol'>
            <div className='formsection'>
              <div className='formheader'>
                <h2>
                  <IntlMessage ident='project.form.stepStatusFormTitle' />
                </h2>
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <ProjectStatus
                    value={this.state.status}
                    onChange={this._onChangeProjectStatus.bind(this)}
                  />
                </div>
              </div>
              {this.state.status === 'closed' && (
                <div className='formrow'>
                  <div className='formcol2'>
                    <FormDatePicker
                      label='project.form.projectCloseDate'
                      placeholder='project.form.projectCloseDate'
                      value={closeDate}
                      name='closeDate'
                      onChange={this._onChangeDate.bind(this, 'closeDate')}
                    />
                  </div>
                  <div className='formcol2'>
                    <FormButton
                      title='project.form.actionToday'
                      type='text'
                      className={`wizard${
                        this.state.closeDate && this.state.closeDate.bToday
                          ? ''
                          : 'alt'
                      }`}
                      onClick={this._onClickDate.bind(
                        this,
                        'closeDate',
                        'today'
                      )}
                    />
                    <FormButton
                      title='project.form.actionYesterday'
                      type='text'
                      className={`wizard${
                        this.state.closeDate && this.state.closeDate.bToday
                          ? 'alt'
                          : ''
                      }`}
                      onClick={this._onClickDate.bind(
                        this,
                        'closeDate',
                        'yesterday'
                      )}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProjectForm
